/*
 * @Author: along longwang6@163.com
 * @Date: 2026-04-24 19:30:12
 * @LastEditors: along longwang6@163.com
 * @LastEditTime: 2026-05-22 16:08:37
 * @FilePath: /ehr-web/src/utils/tabPolicy.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { resolveRouteTabMeta } from '../router/routeMeta';

type TabPolicyOptions = {
  explicitNewTab?: boolean;
};

export const NOT_FOUND_TAB_TITLE = '页面未找到';

export const normalizeToFullPath = (to: string) => {
  const [path, search = ''] = to.split('?');
  const pathname = path || '/';
  const normalizedSearch = search ? `?${search}` : '';
  return {
    path: pathname,
    search: normalizedSearch,
    fullPath: `${pathname}${normalizedSearch}`,
  };
};

export const matchWhitelist = (path: string) => {
  const tabMeta = resolveRouteTabMeta(path, '', path);
  return tabMeta.tabMode === 'new';
};

export const navigateWithTabPolicy = (
  to: string,
  options: TabPolicyOptions = {}
) => {
  const target = normalizeToFullPath(to);
  const tabMeta = resolveRouteTabMeta(
    target.path,
    target.search,
    target.fullPath
  );
  const shouldOpenNewTab = options.explicitNewTab || tabMeta.tabMode === 'new';
  return {
    ...target,
    tabKey: tabMeta.tabKey,
    tabMode: tabMeta.tabMode,
    cacheStrategy: tabMeta.cacheStrategy,
    tabTitle: tabMeta.title,
    shouldOpenNewTab,
  };
};

export const pickTabOpenTitle = ({
  routeMetaTitle,
  resolvedTitle,
  hasDynamicTitle,
}: {
  routeMetaTitle?: string;
  resolvedTitle?: string;
  hasDynamicTitle?: boolean;
}) => {
  const normalizedRouteMetaTitle = routeMetaTitle?.trim() ?? '';
  const normalizedResolvedTitle = resolvedTitle?.trim() ?? '';

  if (normalizedRouteMetaTitle === '' && normalizedResolvedTitle !== '') {
    return normalizedResolvedTitle;
  }
  if (normalizedResolvedTitle === '' && normalizedRouteMetaTitle !== '') {
    return normalizedRouteMetaTitle;
  }

  return hasDynamicTitle ? normalizedResolvedTitle : normalizedRouteMetaTitle;
};

export const resolveMatchedRouteTabTitle = ({
  routeKey,
  menuRouteName,
  matchedRouteName,
  dynamicName,
  hasRouteMatch,
}: {
  routeKey?: string;
  menuRouteName?: string;
  matchedRouteName?: string;
  dynamicName?: string;
  hasRouteMatch: boolean;
}) => {
  const normalizedDynamicName = dynamicName?.trim() ?? '';
  if (menuRouteName) {
    return normalizedDynamicName
      ? `${menuRouteName}-${normalizedDynamicName}`
      : menuRouteName;
  }

  if (!hasRouteMatch) {
    return NOT_FOUND_TAB_TITLE;
  }

  const baseTitle = matchedRouteName || routeKey || '未命名页面';
  return normalizedDynamicName
    ? `${baseTitle}-${normalizedDynamicName}`
    : baseTitle;
};
